/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ message: NonNullable<unknown> }} Audio_Description_Rephrase_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to rephrase text. {message}" |
*
* @param {Audio_Description_Rephrase_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_rephrase_failed_toast = /** @type {((inputs: Audio_Description_Rephrase_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Rephrase_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec de la reformulation du texte. ${i?.message}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Textumformulierung fehlgeschlagen. ${i?.message}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile riformulare il testo. ${i?.message}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось перефразировать текст. ${i?.message}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo reformular el texto. ${i?.message}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`文本重写失败。${i?.message}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`テキストの言い換えに失敗しました。${i?.message}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`पाठ को पुनः परिभाषित करने में विफल। ${i?.message}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível reformular o texto. ${i?.message}`)
	return /** @type {LocalizedString} */ (`Failed to rephrase text. ${i?.message}`)
});